<template>
  <main-template>
    <v-row class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          {{
            isAdmin && colaboradorId ? "Registros Remotos do Colaborador" : "Meus Registros Remotos"
          }}
        </h1>
      </v-col>
    </v-row>
    <v-row class="mb-3">
      <v-col cols="auto">
        <v-btn color="primary" :to="{ name: 'colaboradores.batidasRemotas.novo' }">
          <v-icon left>mdi-plus</v-icon>
          Novo Registro Remoto
        </v-btn>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-card-title class="py-3 px-4 d-flex align-center flex-wrap">
        <span class="subtitle-1 font-weight-bold mr-4">Histórico de Solicitações</span>
        <v-spacer />
        <v-autocomplete
          v-if="isAdmin"
          v-model="colaboradorId"
          :items="colaboradores"
          item-text="name"
          item-value="id"
          label="Filtrar por colaborador"
          prepend-inner-icon="mdi-account-search-outline"
          outlined
          dense
          hide-details
          clearable
          style="max-width: 360px"
        />
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <v-data-table
          :headers="tableHeaders"
          :items="batidas"
          :loading="carregando"
          no-data-text="Nenhuma solicitação enviada"
          loading-text="Carregando..."
        >
          <template #[`item.colaborador.name`]="{ item }">
            {{ item.colaborador?.name || "—" }}
          </template>
          <template #[`item.data`]="{ item }">
            {{ formatarData(item.data) }}
          </template>
          <template #[`item.hora`]="{ item }">
            {{ formatarHora(item.hora) }}
          </template>
          <template #[`item.tipo_batida`]="{ item }">
            {{ formatarTipo(item.tipo_batida) }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip small :color="corStatus(item.status)" dark>
              {{ item.status.toUpperCase() }}
            </v-chip>
          </template>
          <template #[`item.acoes`]="{ item }">
            <v-tooltip bottom>
              <template #activator="{ on }">
                <v-btn icon small color="primary" v-on="on" @click="visualizar(item)">
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogVisualizar" max-width="520">
      <v-card class="rounded-lg" v-if="itemVisualizado">
        <v-card-title
          class="primary white--text py-3 px-4 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-2">mdi-map-marker-path</v-icon>
            <span class="text-h6 font-weight-bold">Detalhes da Solicitação</span>
          </div>
          <v-chip
            small
            :color="corStatus(itemVisualizado.status)"
            class="font-weight-bold white--text text-capitalize"
          >
            {{ itemVisualizado.status }}
          </v-chip>
        </v-card-title>

        <v-card-text class="pt-4 pb-2 px-4">
          <v-card outlined class="mb-4 grey lighten-5">
            <v-card-text class="py-3">
              <div
                v-if="itemVisualizado.colaborador"
                class="subtitle-1 font-weight-bold primary--text mb-1"
              >
                {{ itemVisualizado.colaborador.name }}
              </div>
              <v-row dense class="caption">
                <v-col cols="6"
                  >Data: <strong>{{ formatarData(itemVisualizado.data) }}</strong></v-col
                >
                <v-col cols="6"
                  >Horário:
                  <strong class="primary--text">{{
                    formatarHora(itemVisualizado.hora)
                  }}</strong></v-col
                >
                <v-col cols="6"
                  >Tipo: <strong>{{ formatarTipo(itemVisualizado.tipo_batida) }}</strong></v-col
                >
                <v-col cols="6"
                  >Enviado em:
                  <strong>{{ formatarDataHora(itemVisualizado.created_at) }}</strong></v-col
                >
              </v-row>
              <v-divider class="my-2"></v-divider>
              <div class="caption font-weight-bold grey--text">Justificativa Informada:</div>
              <div
                class="body-2 font-italic grey--text text--darken-3 mt-1"
                style="white-space: pre-line"
              >
                "{{ itemVisualizado.justificativa }}"
              </div>
            </v-card-text>
          </v-card>

          <v-card outlined class="mb-3" v-if="isAdmin && itemVisualizado.latitude">
            <v-card-text class="py-2">
              <div class="caption font-weight-bold grey--text">Metadados de Geolocalização:</div>
              <v-row dense class="caption mt-1">
                <v-col cols="6"
                  >Latitude: <strong>{{ itemVisualizado.latitude }}</strong></v-col
                >
                <v-col cols="6"
                  >Longitude: <strong>{{ itemVisualizado.longitude }}</strong></v-col
                >
                <v-col cols="6"
                  >Precisão:
                  <strong>{{
                    itemVisualizado.precisao ? itemVisualizado.precisao + "m" : "—"
                  }}</strong></v-col
                >
                <v-col cols="6"
                  >Capturado em:
                  <strong>{{ formatarDataHora(itemVisualizado.geolocalizacao_at) }}</strong></v-col
                >
                <v-col cols="6"
                  >IP Usuário: <strong>{{ itemVisualizado.ip_address || "—" }}</strong></v-col
                >
                <v-col cols="6"
                  >Dispositivo: <strong>{{ itemVisualizado.device_info || "—" }}</strong></v-col
                >
              </v-row>
              <v-btn
                small
                color="primary"
                outlined
                class="mt-2 font-weight-bold"
                :href="`https://www.google.com/maps/search/?api=1&query=${itemVisualizado.latitude},${itemVisualizado.longitude}`"
                target="_blank"
              >
                <v-icon left small>mdi-google-maps</v-icon>
                Ver no Google Maps
              </v-btn>
            </v-card-text>
          </v-card>

          <v-card
            outlined
            class="mb-3 border-left-blue"
            v-if="itemVisualizado.status !== 'pendente'"
          >
            <v-card-text class="py-2">
              <div class="caption font-weight-bold grey--text">Resultado da Avaliação:</div>
              <v-row dense class="caption mt-1">
                <v-col cols="6" v-if="itemVisualizado.aprovador">
                  Avaliado por: <strong>{{ itemVisualizado.aprovador.name }}</strong>
                </v-col>
              </v-row>
              <div
                v-if="itemVisualizado.status === 'rejeitado' && itemVisualizado.motivo_rejeicao"
                class="mt-2"
              >
                <div class="caption font-weight-bold grey--text">Motivo da Rejeição:</div>
                <div class="body-2 font-italic error--text grey lighten-4 pa-2 rounded mt-1 border">
                  "{{ itemVisualizado.motivo_rejeicao }}"
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3 px-4 bg-grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey" class="font-weight-bold" @click="dialogVisualizar = false"
            >Fechar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "BatidasRemotasPage",
  data() {
    return {
      batidas: [],
      carregando: false,
      dialogVisualizar: false,
      itemVisualizado: null,
      colaboradorId: null,
      colaboradores: [],
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    isAdmin() {
      return (
        this.user?.roles?.filter(
          (role) =>
            role.name === "super-admin" ||
            role.name === "admin" ||
            role.name === "TI" ||
            role.name === "lider"
        ).length >= 1
      );
    },
    tableHeaders() {
      const base = [
        { text: "Data", value: "data" },
        { text: "Horário", value: "hora" },
        { text: "Tipo", value: "tipo_batida" },
        { text: "Justificativa", value: "justificativa" },
        { text: "Status", value: "status" },
        { text: "", value: "acoes", sortable: false, align: "center", width: "80" },
      ];
      if (this.isAdmin) {
        base.unshift({ text: "Colaborador", value: "colaborador.name" });
      }
      return base;
    },
  },
  watch: {
    colaboradorId() {
      this.carregar();
    },
  },
  mounted() {
    this.carregar();
    if (this.isAdmin) {
      this.carregarColaboradores();
    }
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        const params = {};
        if (this.isAdmin && this.colaboradorId) {
          params.colaborador_id = this.colaboradorId;
        }
        this.batidas = await this.$services.colaboradorPontosService.listarMinhasBatidasRemotas(
          params
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    async carregarColaboradores() {
      try {
        this.colaboradores = await this.$services.colaboradorPontosService.listarColaboradores();
      } catch (error) {
        this.$handleError(error);
      }
    },
    visualizar(item) {
      this.itemVisualizado = item;
      this.dialogVisualizar = true;
    },
    corStatus(status) {
      return { pendente: "orange", aprovado: "green", rejeitado: "red" }[status] || "grey";
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarHora(hora) {
      if (!hora) return "—";
      return String(hora).substring(0, 5);
    },
    formatarTipo(tipo) {
      const map = {
        entrada: "Entrada",
        saida_almoco: "Saída Almoço",
        retorno_almoco: "Retorno Almoço",
        saida: "Saída",
      };
      return map[tipo] || tipo;
    },
    formatarDataHora(data) {
      if (!data) return "—";
      return new Date(data).toLocaleString("pt-BR");
    },
  },
};
</script>
